// Environment resolves from the served hostname so a build can never ship
// pointing at the wrong backend (it used to be a hardcoded constant, and a
// prod deploy would have gone out reading the tests endpoints). Set to
// "prod" or "home" to override during local development.
const FORCE_ENV: "prod" | "home" | null = null;

function detectEnv(): "prod" | "home" {
  if (FORCE_ENV) return FORCE_ENV;

  if (
    typeof window !== "undefined" &&
    /(^|\.)pay\.ginastee\.com$/.test(window.location.hostname)
  ) {
    return "prod";
  }

  return "home";
}

const env = detectEnv();

const Config = {
  prod: {
    apiEndpoint: "https://core.ginastee.com/api",
    payEndpoint: "https://payments.ginastee.com/pay",
    // Render-time key comes from the API (GET /checkout/product ships
    // stripePublishableKey; the intent response carries it too) — this
    // config value is only a last-resort fallback and stays empty in prod.
    stripePublishableKey: "",

    googlePlacesApiKey: "AIzaSyCtACR9J-RKolWt8d3UTKB-wy4q2C7ps14",

    authEndpoint: "https://auth.ginastee.com",
  },
  home: {
    apiEndpoint: "https://tests.core.ginastee.com/api",
    //apiEndpoint: "http://localhost:8000/api",
    payEndpoint: "https://test-payments.ginastee.com/pay",
    stripePublishableKey: "pk_test_51TpoDJDh6rDgQEBtyCMF3qqD6uh3WugyfjHofee0jAKlApG7tpDWhv0VC2Ct3Ji0dl3ItTDTYexRIoSbxsNTH9dy00zKJAnPx0",

    googlePlacesApiKey: "AIzaSyCtACR9J-RKolWt8d3UTKB-wy4q2C7ps14",

    //authEndpoint: "https://auth-test.ginastee.com",
    authEndpoint: "http://localhost:3002",
  },
  apiToken: getToken(),
};

function getToken() {
  try {
    const token = JSON.parse(localStorage.getItem("token"));
    if (!token) return false;
    return token;
  } catch (e) {
    return false;
  }
}

export default Config[env];

export const environment = env;

export const token = Config.apiToken;
